import React, { useState } from "react";
import styled from "@emotion/styled";
import { PrimaryButton } from "../../Button";
import { AddAccountModal } from "./modals/AddAccountModal";

const AddAccount = () => {
  const [addAccountModalOpen, setAddAccountModalOpen] = useState(false);
  const AddAccountButton = styled(PrimaryButton)`
    width: 199px;
  `;

  return (
    <>
      <AddAccountButton
        onClick={() =>
          setAddAccountModalOpen((addAccountModalOpen) => !addAccountModalOpen)
        }
      >
        Add Account
      </AddAccountButton>
      <AddAccountModal
        isOpen={addAccountModalOpen}
        closeModal={() =>
          setAddAccountModalOpen((addAccountModalOpen) => !addAccountModalOpen)
        }
      />
    </>
  );
};

export { AddAccount };
